import { Dispatch, SetStateAction, useId, useState } from "react";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../../../firebase";
import AdminButton from "../../../core/admin/adminButton";
import AdminSpinner from "../../../core/admin/adminSpinner";
import { UploadIcon } from "../../../../img/svg/adminIcons";


export default function AdFileInput({ adId, isDisabled = true, saveImgUrl, loading, setLoading, mobile }: { adId: string, isDisabled?: boolean, saveImgUrl: (imgField: string, imgUrl: string, nextNumber?: number) => Promise<undefined | null>, loading: boolean, setLoading: Dispatch<SetStateAction<boolean>>, mobile: boolean }) {

    // id único por instância: o modal do anúncio tem dois inputs (desktop e mobile) ao mesmo tempo
    // e, com um id fixo, o rótulo do segundo abria o seletor do primeiro
    const inputId = useId();

    const [picText, setPicText] = useState("");
    const [picValue, setPicValue] = useState<File | null>(null);
    const [picSize, setPicSize] = useState(0);
    // const [prog, setProg] = useState(0);
    // const [cProg, setCProg] = useState(0);
    const [hasError, setHasError] = useState(false);

    const sendImage = async (e: any) => {
        e?.preventDefault?.();
        try {
            setLoading(true);
            setHasError(false);
            let imgUrl = "";
            if (!picValue) {
                setLoading(false);
                return null;
            }
            if (picSize > 5) {
                setLoading(false);
                return null;
            }
            const storageRef = ref(storage, `ads/${adId}/${picText}`);
            const uploadTask = await uploadBytesResumable(storageRef, picValue);
            imgUrl = await getDownloadURL(uploadTask.ref);
            // uploadTask.on("state_changed", (snapshot) => {
            //     const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            //     setProg(progress);
            // }, (error) => {
            //     console.log(error);
            //     setHasError(true);
            //     setLoading(false);
            // }, () => {
            //     getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            //         imgUrl = downloadURL
            //     })
            // });
            saveImgUrl(mobile ? "mImgUrl" : "imgUrl", imgUrl);
            onCancel();
        } catch (error) {
            console.log(error);
            setLoading(false);
        }

    }

    const onChoose = (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            const files = e.target.files;
            if (!files) {
                return null;
            }
            const file = files[0];
            setPicSize(file.size / 1024000);
            setPicValue(file);
            setPicText(file.name);
        } catch (error) {
            console.log(error);
        }
    }

    const onCancel = () => {
        setPicValue(null);
        setPicText("");
        setPicSize(0);
    }

    return (
        <div>
            {
                loading ?
                    <div className="flex h-28 items-center justify-center rounded-lg border-2 border-dashed border-gray-300 text-gray-500">
                        <AdminSpinner />
                    </div>
                    : !picValue ?
                        <label title="Adicionar" htmlFor={inputId} className={`flex h-28 flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed border-gray-300 text-sm text-gray-500 transition ${isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:border-gray-900 hover:text-gray-900"}`}>
                            <UploadIcon />
                            <span className="font-semibold">Selecionar imagem {mobile ? "mobile" : "desktop"}</span>
                            <span className="text-xs text-gray-400">até 5MB</span>
                            <input id={inputId} type="file" accept="image/*" disabled={isDisabled} className="hidden" onChange={e => onChoose(e)} />
                        </label>
                        :
                        <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 p-3">
                            <p className={`flex-1 min-w-0 text-sm break-all ${isDisabled ? "text-gray-400" : picSize > 5 ? "text-red-600 font-semibold" : "text-gray-800"}`}>
                                {picText} {picSize ? `(${picSize.toFixed(2)}MB)` : null}
                                {
                                    picSize > 5 ?
                                        <span className="block text-xs">Arquivo maior que 5MB.</span>
                                        : null
                                }
                            </p>
                            <div className="flex gap-2">
                                <AdminButton size="sm" variant="secondary" onClick={onCancel} className="flex-1">Cancelar</AdminButton>
                                <AdminButton size="sm" disabled={isDisabled || loading || !picValue || picSize > 5} onClick={() => sendImage(null)} className="flex-1">Enviar</AdminButton>
                            </div>
                        </div>
            }
            {
                hasError ?
                    <p className="mt-2 text-sm text-red-600">Erro no envio!</p>
                    : null
            }

        </div>
    )
}
